import { z } from 'zod';
import { ActivityFeatures } from '@/model/Activity/ActivityFeatures.model';

export const dateSchema = z.coerce.date();

export const activityFeaturesSchema = z
  .string()
  .default('')
  .transform((v) =>
    v
      .split(',')
      .map((f) => f.trim())
      .filter((v) => v !== '')
  )
  .pipe(z.array(ActivityFeatures.zodSchema.keyof()));
